import { MediaData } from './media-data';
import { CustomerSiteData } from './customer-site-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class CustomerData {
  CustomerId: string;
  CustomerName: string;
  CustomerReference: string;
  CustomerImage: MediaData;
  CustomerStatusId: string;
  ApprovalExpires: string;
  Latitude: number;
  Longitude: number;
  CustomerAddress: string;
  EmailAddress: string;
  PhoneNumber: string;
  Website: string;
  Sites: CustomerSiteData[];
  HasOpenContracts: boolean;
  Deleted: boolean;
  LastModified: string;
}


